import { Coupon } from '~/hooks/useAppParams';

export const CouponApplied = ({ coupon }: { coupon: keyof typeof Coupon }) => (
  <div className='inline-block text-[10px] px-[0.625rem] py-[0.325rem] bg-blue-300 leading-[100%] rounded-[0.5rem] mb-[0.5rem] text-blue-800'>
    Coupon <span className='font-bold'>{coupon.toUpperCase()}</span> applied
  </div>
);
